import { MDBAlert, MDBBtn, MDBDatatable, MDBIcon, MDBInput, MDBSpinner } from 'mdb-react-ui-kit'
import React, { useEffect, useRef, useState } from 'react'
import { getCorporateContact } from '../../../apiclients/streamsapi_bridge';
import { formattedNumber } from '../../../views/popups/phonenumbers/AddRemoveNumbers';
import  { customSearch, useAutoFocusSearchAfterLoads } from '../../CustomSearchUtil/CustomSearch';
import UIConstant from '../../../apiclients/UIConstant';
import TabIDConstant from '../../../apiclients/TabIDConstant';

function CorporateContacts({isActive}) {
    const [isloading, setIsloading] = useState(false);
    const [internalError, setInternalError] = useState(false);
    const [corporateContacts, setcorporateContacts] = useState([]);
    
    const [searchValue, setsearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [rowdata, setRowData] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,isActive)
    useEffect(() => { 
    let processdrows = [];
    corporateContacts.map((contact) => {
        let phNumber = contact.phnumber ? formattedNumber(contact.phnumber) + "" : ""
        processdrows.push({
            name: contact.agentname + " " + contact.lname,
            email: contact.email,
            extension: contact.extensions,
            actualNumber : phNumber?.toString().replace(/[ ]/g, ''),
            personaldid : phNumber,
            sip: contact.sipuri,
            // sipuser: contact.sip_user ?? '',
            groupname: contact.title,
            phnumber : contact?.phnumber + "" 


        })
    });
    setRowData(processdrows);
    setFilteredRows(processdrows)
    setDataLoaded(true)
},[corporateContacts])

    const actionData2 = {
        columns: [
            { label: 'Name', field: 'name', sort: true },
            { label: 'Email', field: 'email' },
            { label: 'Extension', field: 'extension' },
            { label: 'Personal DID', field: 'personaldid' },
            // { label: 'SIP URI', field: 'sip' },
            { label: 'Group Names', field: 'groupname' },
            // { label: 'Action', field: 'action', sort: false },
        ],
        rows: rowdata,
    };

    useEffect(() => {
        if(isActive){
        getCorporateContacts();
        }
    }, [isActive]);

    async function getCorporateContacts() {
        try {
            setInternalError(false);
            setIsloading(false);
            console.log(sessionStorage.getItem("admin_session"));
            const response = await getCorporateContact(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                TabIDConstant.CORP_CONTACTS_SUBLINK
            );
            setIsloading(true);
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            const rawData = await response.json();
            if (!rawData) {
                setInternalError(true);
            }
            console.log("setcorporateContacts data :::::::::: " + JSON.stringify(rawData));
            setcorporateContacts(rawData?.corporateContactDtls ?? []);
            setTimeout(() => {
                setIsloading(false);
            }, 1000);

        } catch (error) {

        }
    }

    const handleManualSearch = (searchValue) => {
        setsearchValue(searchValue);
        const filteredUsers = customSearch(rowdata, searchValue, UIConstant.CORPORATE_CONTACTS);

        setFilteredRows(filteredUsers);
    };



    return (
        <>
            <div className='contactsTable'>
            
                <div className="actionbar"></div>
                <div className='mb-2 mt-2 position-relative w-auto'>
                    <MDBInput ref={searchRef} label="Search" value={searchValue}  onChange={(e) => handleManualSearch(e.target.value)} />
                    <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                </div>
                <MDBDatatable hover sortField="Name" 
                 key={searchValue}
                data={{
                    ...actionData2,
                    rows: filteredRows, // Use filtered rows here
                  }}
                entries={50} />
            </div>
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
            {internalError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setInternalError(false)}
                >
                    Internal Server Error
                </MDBAlert>
            )}

        </>
    )
}

export default CorporateContacts
